import { GlobalStyles } from '@minted/minted-components';
import { NextPageContext } from 'next';
import dynamic from 'next/dynamic';
import { useEffect } from 'react';

import styles from '../styles/Modal.module.css';
import { getMonoUrl } from '../utils/public/ClientUtils';
import fetch from '../utils/public/fetch';
import { getWhitelistedIFrameOrigin } from '../utils/public/MintedConfig';
import popupPaths from '../utils/public/popupPaths';

// the sign in can't be ssr'ed.
const ResetPassword = dynamic(
  () => import('../components/ResetPasswordComponent'),
  {
    ssr: false,
  }
);

const App = ({
  currentHost,
}: {currentHost: string}) => {
  useEffect(() => {
    // Make API call to check login status and refresh tokens if need be.
    (async () => {
      await fetch('/api/check-login-status-and-refresh', {
        method: 'POST',
      });
    })();

    return () => {
    };
  }, []);

  const onSuccessfulReset = () => {
    // @ts-ignore
    if (window && window.parent) {
      window.parent.postMessage('reset', getWhitelistedIFrameOrigin());
    }
  };

  return (
    <div>
      <GlobalStyles />
      <div className={styles.main}>
        <div className={styles.header}>
          reset your password
        </div>
        <ResetPassword
          continueShoppingUrl={getMonoUrl(currentHost)}
          onSuccessfulReset={onSuccessfulReset}
          paths={popupPaths}
        />
      </div>
    </div>
  );
};

// opt-out of static optimization so runtime config is available
export const getServerSideProps = async (context: NextPageContext) => ({
  props: {
    currentHost: context.req?.headers.host || '',
  },
});

export default App;
